{
  "title": "如何查詢與管理已繳交的作品",
  "description": "在投稿管理頁查詢、篩選並檢視各隊伍的作品繳交狀況。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，您能掌握各隊伍的投稿進度，並視需要進行鎖定、解鎖、撤回等操作。",
  "roleNote": "競賽管理員／具 submission.read.all 權限的工作人員",
  "prerequisites": ["競賽已建立", "至少已有一支隊伍開始填寫投稿表單"],
  "pathLabel": "主辦方後台 → 我的競賽 → 投稿管理",
  "steps": [
    {
      "title": "1. 開啟投稿管理",
      "description": "進入指定競賽後，點選「投稿管理」；此頁面需要 submission.read.all 權限。"
    },
    {
      "title": "2. 篩選投稿清單",
      "description": "投稿清單支援依狀態（草稿／就緒／已提交／已鎖定／已撤回／已取消資格）篩選、依輪次（初賽／決賽）與組別篩選、依隊伍 ID 文字搜尋，並提供分頁；資料表依序顯示隊伍、輪次、組別、狀態、提交時間（同一隊的初賽與決賽作品各自一列，決賽作品不會覆蓋初賽作品）。"
    },
    {
      "title": "3. 查看投稿詳情",
      "description": "點開任一筆投稿可查看狀態徽章、提交時間、所屬隊伍名稱，以及所有已上傳檔案與參賽者填寫的表單答案；檔案皆提供「線上預覽」與「下載」。"
    },
    {
      "title": "4. 視需要進行狀態操作",
      "description": "若您具備 submission.manage 權限，投稿詳情頁會顯示對應的操作按鈕：對「已提交」的投稿可以「鎖定」；對「已提交」或「已鎖定」的投稿可以「解鎖」（轉回可編輯狀態，不寄信通知）、「撤回」、「取消資格」，或「退回修正」（會寄信通知團隊成員並要求填寫理由）。"
    }
  ],
  "afterward": [
    "投稿清單反映最新的篩選結果",
    "投稿詳情頁顯示完整版本歷程，唯讀呈現",
    "若同時具備 score.read 或 score.manage 權限，同一頁也會看到各評審的評分"
  ],
  "nextSteps": "確認投稿狀況後，可以前往「評審設定」分頁指派作品給評審，或視需要對個別投稿進行狀態調整。",
  "faq": [
    {
      "q": "為什麼有些操作按鈕看不到？",
      "a": "投稿狀態操作（鎖定／解鎖／撤回／取消資格／退回修正）需要 submission.manage 權限；若只具備 submission.read.all，只能查詢與檢視，看不到這些操作按鈕。"
    },
    {
      "q": "退回修正跟解鎖有什麼差別？",
      "a": "兩者都會把投稿轉回可編輯狀態，差別在於退回修正是刻意面向團隊溝通的操作：必填理由，且會寄送 Email 通知團隊的非指導老師成員說明需要修改的地方；解鎖則不寄送通知。"
    }
  ]
}
